import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export const isDateAfter: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
  const start = control.get('fechaInicio')?.value;
  const end = control.get('fechaFin')?.value;

  if (!start || !end) {
    return null;
  }
  const startDate = Date.parse(start);
  const endDate = Date.parse(end);

  const invalid = endDate < startDate
  return invalid ? { invalid_date: true } : null;
}

export const dateNotPastValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  console.log("--- dateNotPastValidator START ---");
  console.log("Control Value:", control.value);

  if (!control.value) {
    console.log("Value is empty, returning null");
    return null;
  }
  
  const selectedDate = new Date(control.value);
  const now = new Date();

  selectedDate.setSeconds(0, 0);
  now.setSeconds(0, 0);


  if (isNaN(selectedDate.getTime())) {
    console.log("Invalid Date detected, returning null");
    return null;
  }

  const isPast = selectedDate.getTime() < now.getTime();
  console.log("Comparison Result (isPast):", isPast);
  console.log("--- dateNotPastValidator END ---");

  return isPast ? { pastDate: true } : null;
}

export const numberZeroOrGreaterThanOne: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value = Number(control.value)

  if (Number.isNaN(value)) return { invalid_number: true }

  if (value < 0 || value === 1) return { invalid_number: true }

  return null
}
